import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetHistoricalExchangeDataRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetHistoricalExchangeDataResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getHistoricalExchangeData = (request: GetHistoricalExchangeDataRequest, options?: CashRequestOptions) =>
  post<GetHistoricalExchangeDataRequest, GetHistoricalExchangeDataResponse>(
    '/2.0/cash/get-historical-exchange-data',
    request,
    { ...options, rejectOnError: true }
  )
